module.exports = __webpack_public_path__ + "static/media/codeable-logo.8a6dc6c9.svg";